export default "__VITE_ASSET__a4b2e8b2__"